import {
    apiRequest,
    employeeWFHDetail
} from "../../../../../services/adapters/kepegawaian/employeeWFHService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", employeeWFHDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository